import { useState } from "react";
import { useActaDetalleStore } from "../../../../../store/actaDetalleStore";
import Mapa from "../../../../../components/Mapa";
import { Badge } from "react-bootstrap";

const TabMotivo = () => {

    const { actaDetalle } = useActaDetalleStore();
    const { acta, archivos } = actaDetalle
    const { motivo_no_notificado: motivo } = acta;

    const [imagenSelect, setImagenSelect] = useState(archivos?.fotos_comprimidas ? archivos?.fotos_comprimidas[0]?.file : archivos?.fotos[0]?.file);

    return (
        <>
            <div className="mx-auto ">
                <section className=" align-items-start gap-0">
                    <div className="  align-items-center d-flex gap-2 my-3">
                        <h6 className="m-0 ps-2   text-dark  py-1 " style={{width: "fit-content", lineHeight: "14px" }}>Motivo: </h6>
                        {/* <p className="m-0 fw-bold text-primary " style={{ fontSize: "14px" }}>Motivo: </p> */}
                        <h5>
                            <Badge style={{verticalAlign:"middle"}} bg="danger">{motivo[0]?.motivo}</Badge>
                        </h5>
                    </div>
                    {/* <hr className="my-2"/> */}
                    <div className="d-flex flex-column aling-items-center">
                        {/* <p className="m-0 fw-bold text-primary fs-4">Observación: </p> */}
                        <h6 className="m-0 ps-2 pe-5 mb-2 text-dark  py-1 " style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "14px" }}>Observación</h6>
                        <p className="m-0 fw-normal  border border-1 border-secondary-subtle rounded px-4 py-2 " style={{ fontSize: "14px", width:"fit-content" }}>{acta.observacion_notificador} </p>
                    </div>
                    <hr />
                    <div className="d-flex  col-12 row">
                        <div className="col-6">
                            {/* <p className="m-0 fw-bold text-primary fs-4 w-100">Ubicación: </p> */}
                            <h6 className="m-0 ps-2 pe-5  text-dark  py-1 " style={{  width: "fit-content", lineHeight: "14px" }}>Ubicación</h6>

                            <div style={{ height: "300px" }} >
                                <Mapa latitud={Number(motivo[0]?.latitud)} longitud={Number(motivo[0]?.longitud)} />
                            </div>
                        </div>
                        <div className="col-6">
                            {/* <p className="m-0 fw-bold text-primary fs-4 w-100">Imagen: </p> */}
                            <h6 className="m-0 ps-2 pe-5  text-dark  py-1 " style={{  width: "fit-content", lineHeight: "14px" }}>Imagen</h6>

                            <div style={{ height: "300px" }} >
                                <img src={archivos?.fotoNoNotificada?.file} alt="foto-no-notificada" className="w-100 h-100" style={{ objectFit: "cover" }} />
                            </div>
                        </div>
                    </div>

                </section>
            </div>
        </>
    );
}
export default TabMotivo;